import { LegalLayout } from "@/components/LegalLayout";
import { useLang } from "@/i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  return <LegalLayout doc={t.legal.privacyPolicy} testId="privacy-page" />;
}
